export interface Game {
  id: string;
  title: string;
  category: string;
  image: string;
  description?: string;
  isNew?: boolean;
  isHot?: boolean;
  externalUrl?: string;
  orientation?: 'portrait' | 'landscape';
  enable?: boolean;
}

export const games: Game[] = [
  {
    id: "SaveTheKing",
    title: 'Save The King',
    category: 'Moba',
    image: '/images/games/savetheking.jpg',
    description: 'Strategy game, protect the king from enemy attacks',
    isNew: true,
    orientation: 'portrait',
    enable: true
  },
  {
    id: 'FishTankFury',
    title: 'Fish Tank Fury',
    category: 'IO',
    image: '/images/games/Fish Tank Fury.jpg',
    description: 'Fish tank game',
    isHot: true,
    orientation: 'portrait',
    enable: true
  },
  {
    id: "KittyEscape",
    title: 'Kitty Escape',
    category: 'Puzzle',
    image: '/images/games/Kitty-Escape.jpg',
    description: 'Help the cat escape the maze',
    isHot: true,
    orientation: 'portrait',
    enable: true
  },
  {
    id: "KittyCrushSaga",
    title: 'Kitty Crush Saga',
    category: 'Arcade-Puzzle',
    image: '/images/games/Kitty Crush Saga.jpg',
    description: 'Puzzle game',
    orientation: 'portrait',
    enable: true
  },
  {
    id: "CapybaraLink",
    title: 'Capybara Link',
    category: 'Puzzle',
    image: '/images/games/CapybaraLink.jpg',
    description: 'Puzzle game',
    orientation: 'portrait',
    enable: true
  },
  {
    id: "dd",
    title: 'Doge Dungeon',
    category: 'RPG',
    image: '/images/dogeGame.jpg',
    description: 'Puzzle game',
    externalUrl: 'https://dddemo.playsout.com/',
    orientation: 'landscape',
    enable: false
  },
];

// 按类别分组的游戏
export const gamesByCategory = {
  'Moba': games.filter(game => game.category === 'Moba' && game.enable !== false),
  'RPG': games.filter(game => game.category === 'RPG' && game.enable !== false),
  'IO': games.filter(game => game.category === 'IO' && game.enable !== false),
  'Puzzle': games.filter(game => game.category === 'Puzzle' && game.enable !== false),
  'Arcade-Puzzle': games.filter(game => game.category === 'Arcade-Puzzle' && game.enable !== false),
};

// 获取新游戏
export const getNewGames = (): Game[] => {
  return games.filter(game => game.isNew && game.enable !== false);
};

// 获取热门游戏
export const getHotGames = (): Game[] => {
  return games.filter(game => game.isHot && game.enable !== false);
};

// 根据ID获取游戏
export const getGameById = (id: string): Game | undefined => {
  return games.find(game => game.id === id && game.enable !== false);
};

// 获取所有游戏类别
export const getAllCategories = (): string[] => {
  return Array.from(new Set(games.filter(game => game.enable !== false).map(game => game.category)));
};

// 获取所有启用的游戏
export const getEnabledGames = (): Game[] => {
  return games.filter(game => game.enable !== false);
}; 